import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const AssetModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.5 16C13.5 15.1716 12.8284 14.5 12 14.5C11.1716 14.5 10.5 15.1716 10.5 16V16.25C10.5 17.2165 9.7165 18 8.75 18H7C6.44772 18 6 18.4477 6 19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19C18 18.4477 17.5523 18 17 18H15.25C14.2835 18 13.5 17.2165 13.5 16.25V16Z"
            fill="url(#paint0_linear_123_14403)"
          />
          <path
            d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V14C20 15.1046 19.1046 16 18 16H6C4.89543 16 4 15.1046 4 14V6Z"
            fill="url(#paint1_linear_123_14403)"
          />
          <rect x="7" y="7.5" width="9" height="1" rx="0.5" fill="#570633" />
          <path
            d="M7 10C7 9.72386 7.22386 9.5 7.5 9.5H11.5C11.7761 9.5 12 9.72386 12 10C12 10.2761 11.7761 10.5 11.5 10.5H7.5C7.22386 10.5 7 10.2761 7 10Z"
            fill="#570633"
          />
          <path
            d="M7 12C7 11.7239 7.22386 11.5 7.5 11.5H9.5C9.77614 11.5 10 11.7239 10 12C10 12.2761 9.77614 12.5 9.5 12.5H7.5C7.22386 12.5 7 12.2761 7 12Z"
            fill="#570633"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_14403"
              x1="12"
              y1="18"
              x2="12"
              y2="20.6875"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FA3CFF" />
              <stop offset="1" stop-color="#FFB0F0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_123_14403"
              x1="12"
              y1="4"
              x2="12"
              y2="17.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FA3CFF" />
              <stop offset="1" stop-color="#FFB0E7" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default AssetModule;
